import React, { Fragment, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

const GeoMapLegends = ({ data = [], handleAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleAction = (action) => {
    handleAction(action);
    handleClose();
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  if (data.length) {
    return (
      <Fragment>
        <div className="popover_menu">
          <IconButton className="popover_menu__icon" onClick={handleClick}>
            ...
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <div className="popover_menu__optionWrapper">
              <button
                className="popover_menu__option"
                type="button"
                onClick={() => _handleAction('export')}
              >
                Export as PPT
              </button>
              <button
                className="popover_menu__option"
                type="button"
                onClick={() => _handleAction('edit')}
              >
                Edit
              </button>
            </div>
          </Popover>
        </div>
        <div>
          <h6 className="heatMapLegends__title">Index</h6>
          <ul className="heatMapLegends__items">
            {data.map(item => {
              return (
                <li className="heatMapLegends__item" key={item.indexGroup}>
                  <svg
                    width="18"
                    height="18"
                    className={`heatMapLegends__color ${item.colorCode}`}
                  >
                    <rect width="18" height="18" />
                  </svg>
                  <span className="heatMapLegends__range">
                    {item.indexGroup}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div>&nbsp;</div>
      </Fragment>
    );
  }

  return null;
};

export default GeoMapLegends;
